import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {analyticsRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {AnalyticsCloud} from './pages/AnalyticsCloud/AnalyticsCloud';

export const AnalyticsModule: Module = {
  id: moduleKeys.analytics,
  layoutProps: {
    title: 'analytics.label.title',
    icon: 'sidebar/analytics',
  },
  routerProps: {
    path: analyticsRoutes.cloudOverview,
  },
  requiredPermission: permissions.reportingRead,
  content: [
    {
      id: 'analytics-cloud-overview',
      requiredPermission: permissions.reportingRead,
      routerProps: {
        path: analyticsRoutes.cloudOverview,
        element: <AnalyticsCloud />,
      },
      layoutProps: {
        title: 'analytics.label.managerialReporting',
        icon: 'sidebar/analytics',
      },
    },
    {
      id: 'analytics-cloud-dashboard',
      requiredPermission: permissions.reportingRead,
      routerProps: {
        path: analyticsRoutes.cloudDashboard,
        element: <AnalyticsCloud />,
      },
    },
  ],
};
